module.exports = __webpack_public_path__ + "static/media/colmena.09f5955c.png";